import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, theme } from "../../theme";
import { Icon } from "../../icon";
import { Text as BaseText } from "../../text";
export const LockIcon = ({ className, label }) => (_jsxs(Container, { className: className, children: [_jsx(Icon, { name: "lock", color: theme.color.darkBlue60, title: label }), _jsx(Text, { children: label })] }));
LockIcon.defaultProps = {
    label: "Locked",
};
const Container = styled.div `
  flex-direction: row;
  align-items: center;
  cursor: not-allowed;

  i {
    font-size: 1.5em;
  }

  @media (min-width: ${theme.breakpoint.md}px) {
    min-width: fit-content;
  }
`;
const Text = styled(BaseText) `
  font-size: 0.875em;
  padding-left: ${({ theme }) => theme.space[1]}px;
  color: ${({ theme }) => theme.color.darkBlue60};

  display: none;
  @media (min-width: ${theme.breakpoint.md}px) {
    display: inline;
  }
`;
